import { Badge } from "./ui/badge";
import { Pill, Star } from "lucide-react";

const PHARMACY_CATEGORIES = [
  { name: "Prescription Drugs", color: "#E5DEFF", darkColor: "#312e4b" },
  { name: "Over the Counter", color: "#FEF7CD", darkColor: "#3d3a2e" },
  { name: "Health & Wellness", color: "#F2FCE2", darkColor: "#2e3d2e" },
  { name: "Medical Supplies", color: "#D3E4FD", darkColor: "#2e354d" },
];

export function Hero() {
  return (
    <div className="relative bg-[#F1F0FB] dark:bg-gray-900 py-20 transition-colors duration-200">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-[#1A1F2C] dark:text-white">
            Your Health, Delivered with Care
          </h1>
          <p className="text-lg md:text-xl text-muted-foreground mb-4">
            Access quality medications and healthcare products with professional guidance, 
            delivered right to your doorstep.
          </p>
          <div className="flex flex-wrap gap-2 mb-4">
            {PHARMACY_CATEGORIES.map((category) => (
              <Badge 
                key={category.name} 
                variant="secondary" 
                className="rounded-full text-xs flex items-center gap-1 transition-colors duration-200"
                style={{ 
                  backgroundColor: document.documentElement.classList.contains('dark') 
                    ? category.darkColor 
                    : category.color 
                }}
              >
                <Pill className="h-3 w-3" />
                {category.name}
              </Badge>
            ))}
          </div>
          <div className="flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-yellow-400 text-yellow-400" />
            ))}
            <span className="text-sm text-muted-foreground ml-2">(2,405 Reviews)</span>
          </div>
        </div>
      </div>
      <div className="absolute inset-y-0 right-0 w-1/3 bg-[url('https://images.unsplash.com/photo-1631549916768-4119b2e5f926?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80')] bg-cover bg-center hidden lg:block opacity-100 dark:opacity-70" />
    </div>
  );
}